import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { C } from './theme';
import { useAuth } from '../context/AuthContext';
import ChatbotReports from './reports/ChatbotReports';
import { enableChatbotReportsBoolean } from '../constants/ChatbotReportsConstants';
import { getInitials } from './layout/UserProfileDropdown';

// Same icon approach as Sidebar: Material Symbols Rounded (material-symbols-rounded)
const MSIcon = ({ name, size = 22, color = 'inherit', filled = false, style = {} }: { name: string; size?: number; color?: string; filled?: boolean; style?: React.CSSProperties }) => (
    <span
        className="material-symbols-rounded"
        style={{ fontSize: size, lineHeight: 1, color, userSelect: 'none', flexShrink: 0, fontVariationSettings: filled ? "'FILL' 1" : "'FILL' 0", ...style }}
    >
        {name}
    </span>
);

// Matches mobile-v6-1.jsx NAV: flash_on, bar_chart, auto_awesome (Loyalty hidden)
const NAV_ITEMS = [
    { icon: "flash_on", label: "Snapshot", path: "/reports/snapshot" },
    { icon: "bar_chart", label: "Reports", path: "/reports" },
    { icon: "dashboard", label: "Control Center", path: "/product-catalog" },
    // { icon: "dashboard", label: "Control Center", path: "/product-catalog" },
    { icon: "badge", label: "Employees", path: "/employees" },
    // { icon: "loyalty", label: "Loyalty", path: "/loyalty" },
    ...(enableChatbotReportsBoolean ? [{ icon: "auto_awesome", label: "Maghil AI", path: "/ai" }] : []),
];

const NAV_HEIGHT = 72;
const NAV_PADDING_BOTTOM = "max(8px, env(safe-area-inset-bottom))";

const BottomNav = (_props?: any) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { auth, logout } = useAuth();
    const [profileOpen, setProfileOpen] = useState(false);

    const showChatbot = enableChatbotReportsBoolean && location.pathname === '/ai';
    const SUPER_ROLES = ['Restaurant_Owner', 'Regional_Employee', 'Magil_Admin'];
    const isSuperUser = auth?.role && SUPER_ROLES.includes(auth.role);

    const resolvedItems = NAV_ITEMS.map((item) => {
        if (item.path === '/reports/snapshot' && isSuperUser) {
            return { ...item, label: 'Overview', icon: 'grid_view', path: '/owner-view' };
        }
        return item;
    });

    const ALL_ITEMS = resolvedItems;

    // Match most specific path first
    const matchedIndex = (() => {
        const path = location.pathname;
        if (path.startsWith("/product-catalog")) return ALL_ITEMS.findIndex((n) => n.path?.startsWith("/product-catalog"));
        for (let i = 0; i < ALL_ITEMS.length; i++) {
            const item = ALL_ITEMS[i];
            if (item.path === '/owner-view' && path.startsWith('/reports/snapshot')) return i;
            if (item.path !== "/reports" && path.startsWith(item.path)) return i;
        }
        if (path.startsWith("/reports")) return ALL_ITEMS.findIndex((n) => n.path === "/reports");
        return -1;
    })();
    const activeIndex = matchedIndex;

    return (
        <>
            {showChatbot && (
                <ChatbotReports
                    headerTextReportsChatBot="Maghil Insights"
                    centerTextReportsChatBot="Ask about sales, employees, refunds and trends."
                    messageInputPlaceholderReportsChatBot="Ask me anything..."
                    footerTextReportsChatBot="AI may make mistakes, Check your important info"
                    enableSuggestionsReportsChatBot={true}
                    enableVoiceInputReportsChatBot={false}
                    enableFileUploadReportsChatBot={false}
                    defaultOpen={true}
                    onClose={() => navigate('/reports/snapshot')}
                />
            )}

            {/* Spacer so fixed nav doesn’t cover content */}
            <div style={{ height: NAV_HEIGHT, paddingBottom: NAV_PADDING_BOTTOM, flexShrink: 0 }} />
            <div style={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 1000, height: NAV_HEIGHT, paddingBottom: NAV_PADDING_BOTTOM, boxSizing: "content-box", background: C.surface, borderTop: `1px solid ${C.divider}`, display: "flex", justifyContent: "space-around", alignItems: "center", flexShrink: 0 }}>
                {ALL_ITEMS.map((item, i) => {
                    const isActive = activeIndex === i;
                    return (
                        <div
                            key={i}
                            onClick={() => navigate(item.path)}
                            style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 3, padding: "4px 14px", cursor: "pointer" }}
                        >
                            <MSIcon name={item.icon} size={22} color={isActive ? C.accent : C.t3} filled={isActive} style={{ opacity: isActive ? 1 : 0.45 }} />
                            <span style={{ fontSize: 9.5, fontWeight: isActive ? 700 : 400, color: isActive ? C.accent : C.t3 }}>{item.label}</span>
                            {isActive && <div style={{ width: 4, height: 4, borderRadius: "50%", background: C.accent, boxShadow: `0 0 8px ${C.accent}44`, marginTop: -1 }} />}
                        </div>
                    );
                })}
            </div>
        </>
    );
};

export default BottomNav;

